export default __webpack_public_path__ + "static/media/client26.96a80b72.png";